/**
 * 序列化参数
 * @param params {Object} - 待序列化参数
 * @return queryString - ex: a=1&b=1
 */

const queryString = params => {
  if (!params || typeof params !== "object") {
    window.console.warn("请传入正确的参数")
  }
  let resultArr = []
  Object.keys(params).forEach(key => {
    if (params[key] !== "") {
      if (typeof params[key] === "object") {
        params[key] = JSON.stringify(params[key])
      }
      let item = `${key}=${params[key]}`
      resultArr.push(item)
    }
  })
  return resultArr.join("&")
}

export default queryString
